import { useShowMore } from 'hooks';
import { useAppSelector } from 'store';
import { BackOfficeRoles } from 'types';
import { formatPrice } from 'utils/helpers';
import { AnalyticsProduct } from 'store/api/analytics';
import { selectAuthUserRole } from 'store/slices/auth';
import { TemplateList } from 'components/transactions-list';
import { EmptyPlaceholder, hideCostPriceRoles } from 'config';

import { ProductSoldListProps } from './types';

const cellsMobile = [
  { row: '1/2', col: '1/3' },
  { row: '2/3', col: '1/2' },
  { row: '2/3', col: '2/3' },
];

const getTemplateAndHeaders = (isHideCostPrice: boolean) => {
  let template = '2fr repeat(4, 1fr)';
  let headers = ['Product', 'QTY sold', 'Cost Price', 'Total sold', 'Losses'];

  if (isHideCostPrice) {
    template = '2fr repeat(3, 1fr)';
    headers = ['Product', 'QTY sold', 'Total sold', 'Losses'];
  }

  return { headers, template };
};

export const ProductSoldList = ({ data }: ProductSoldListProps) => {
  const authUserRole = useAppSelector(selectAuthUserRole);
  const isHideCostPrice = hideCostPriceRoles.includes(
    authUserRole as BackOfficeRoles
  );

  const { visibleData, ...showMoreProps } = useShowMore(data);

  const templateConfig = getTemplateAndHeaders(isHideCostPrice);

  return (
    <TemplateList<AnalyticsProduct>
      {...templateConfig}
      data={visibleData}
      hasMinHeight={false}
      title="Products sold"
      cellsMobile={cellsMobile}
      listProps={showMoreProps}
      tabletTemplate={templateConfig.template}
      maxHeight={visibleData?.length ? 350 : undefined}
      render={(product) => {
        const values = [
          product?.product?.name,
          product?.quantity,
          formatPrice(product?.totalSales),
          EmptyPlaceholder,
        ];

        if (!isHideCostPrice) {
          values.splice(2, 0, formatPrice(product?.product?.costPrice));
        }

        return values;
      }}
    />
  );
};
